import React, { useState, useEffect } from 'react';
// 경로 확인: components/system 위치에서 services 폴더로 접근
import { engineerService } from '../../services/engineerService';
import { userService } from '../../services/userService';

const EngineerManager = () => {
  const [engineers, setEngineers] = useState([]);
  const [availableUsers, setAvailableUsers] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  
  const initialForm = { 
    userId: '', name: '', team: '', phone: '', region: '', 
    status: '재직', isRecallWorker: true 
  };
  const [formData, setFormData] = useState(initialForm);

  // --- [에러 해결의 핵심: 비동기 데이터 갱신] ---
  const refresh = async () => {
    setLoading(true);
    try {
      // 1. 등록된 엔지니어 목록 클라우드에서 가져오기
      const engData = await engineerService.getEngineers();
      setEngineers(engData || []);
      
      // 2. 사용자 목록 클라우드에서 가져오기
      const allUsers = await userService.getUsers();
      
      // 3. 승인된 사용자만 필터링 (비동기로 가져온 결과물에 filter 적용)
      const approvedUsers = (allUsers || []).filter(u => u.status === 'APPROVED' || !u.status);
      setAvailableUsers(approvedUsers);

    } catch (error) {
      console.error("데이터 갱신 중 오류 발생:", error);
    }
    setLoading(false);
  };

  useEffect(() => { 
    refresh(); 
  }, []);

  const handleUserSelect = (e) => {
    const selectedUser = availableUsers.find(u => u.email === e.target.value);
    if (selectedUser) {
      setFormData({ ...formData, userId: selectedUser.email, name: selectedUser.name });
    } else {
      setFormData({ ...formData, userId: '', name: '' });
    }
  };

  const onSave = async (e) => {
    e.preventDefault();
    if (!formData.userId) return alert("연동할 사용자 ID를 선택해주세요.");
    
    setLoading(true);
    try {
      if (editId) {
        await engineerService.updateEngineer(editId, formData);
      } else {
        if (engineers.some(eng => eng.userId === formData.userId)) {
          setLoading(false);
          return alert("이미 매핑된 인력입니다.");
        }
        await engineerService.saveEngineer(formData);
      }
      
      setEditId(null);
      setFormData(initialForm);
      await refresh(); // 저장 후 목록 다시 불러오기
      alert("✅ 성공적으로 저장되었습니다.");
    } catch (err) {
      alert("저장에 실패했습니다.");
    }
    setLoading(false);
  };

  // --- [디자인 스타일] ---
  const inputStyle = { width: '100%', padding: '12px', marginTop: '8px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { fontSize: '13px', fontWeight: 'bold', color: '#475569', display: 'block' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
      <section style={{ padding: '30px', background: 'white', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
        <h3 style={{ marginTop: 0, color: '#1e293b', borderBottom: '1px solid #f1f5f9', paddingBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '25px' }}>
          <span style={{fontSize: '24px'}}>🔐</span> 리콜 실행 인력 권한 매핑 (Cloud)
        </h3>
        
        <form onSubmit={onSave} style={{ display: 'flex', gap: '40px' }}>
          <div style={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', columnGap: '25px', rowGap: '25px' }}>
            <div>
              <label style={labelStyle}>승인된 사용자 ID 연동</label>
              <select value={formData.userId} onChange={handleUserSelect} style={{...inputStyle, border: '2px solid #11caa0'}} required>
                <option value="">-- 선택하세요 (승인된 직원 목록) --</option>
                {availableUsers.map(u => (
                  <option key={u.email} value={u.email}>{u.name} ({u.email})</option>
                ))}
              </select>
            </div>
            <div><label style={labelStyle}>엔지니어 성함</label><input value={formData.name} readOnly style={{...inputStyle, background: '#f1f5f9'}} /></div>
            <div>
              <label style={labelStyle}>권한 설정</label>
              <button type="button" onClick={() => setFormData({...formData, isRecallWorker: !formData.isRecallWorker})} style={{ padding: '10px 15px', marginTop: '8px', borderRadius: '6px', border: 'none', background: formData.isRecallWorker ? '#11caa0' : '#e2e8f0', color: formData.isRecallWorker ? 'white' : '#64748b', fontWeight: 'bold', cursor: 'pointer' }}>
                {formData.isRecallWorker ? '✅ 리콜 수행자' : '❌ 일반 유저'}
              </button>
            </div>
            <div><label style={labelStyle}>소속 팀</label><input value={formData.team} onChange={e => setFormData({...formData, team: e.target.value})} style={inputStyle} /></div>
            <div><label style={labelStyle}>연락처</label><input value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} style={inputStyle} /></div>
            <div><label style={labelStyle}>담당 지역</label><input value={formData.region} onChange={e => setFormData({...formData, region: e.target.value})} style={inputStyle} /></div>
            <div style={{ gridColumn: 'span 3' }}>
              <button type="submit" disabled={loading} style={{ width: '100%', background: '#1e293b', color: 'white', border: 'none', padding: '15px', borderRadius: '8px', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer' }}>
                {loading ? "처리 중..." : "인력 확정 및 매핑 저장"}
              </button>
            </div>
          </div>
        </form>
      </section>

      <section style={{ padding: '25px', background: 'white', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
        <h3 style={{ marginTop: 0, color: '#1e293b', marginBottom: '25px' }}>✅ 리콜 수행 인력 마스터 명단 (실시간)</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ background: '#f8fafc', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>
              <th style={{ padding: '15px' }}>사용자 계정</th>
              <th style={{ padding: '15px' }}>성함/팀</th>
              <th style={{ padding: '15px', textAlign: 'center' }}>상태</th>
              <th style={{ padding: '15px', textAlign: 'center' }}>관리</th>
            </tr>
          </thead>
          <tbody>
            {engineers.map(e => (
              <tr key={e.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={{ padding: '12px 15px' }}>{e.userId}</td>
                <td style={{ padding: '12px 15px' }}><strong>{e.name}</strong><br/>{e.team}</td>
                <td style={{ padding: '12px 15px', textAlign: 'center' }}>{e.isRecallWorker ? '수행중' : '제한'}</td>
                <td style={{ padding: '12px 15px', textAlign: 'center' }}>
                  <button onClick={() => {setEditId(e.id); setFormData({...e})}} style={{ color: '#0d6ba1', border: 'none', background: 'none', cursor: 'pointer' }}>수정</button>
                  <button onClick={async () => { if(window.confirm("삭제하시겠습니까?")) { await engineerService.deleteEngineer(e.id); refresh(); } }} style={{ color: '#ef4444', border: 'none', background: 'none', marginLeft: '10px', cursor: 'pointer' }}>삭제</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default EngineerManager;